import { render, staticRenderFns } from "./PRJ303M01.vue?vue&type=template&id=33bcfd7a&"
import script from "./PRJ303M01.vue?vue&type=script&lang=js&"
export * from "./PRJ303M01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports